(function () {
    'use strict';

    function profileDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/profile';

        function loadEntityProfile(entityId) {
            return $http.get(baseUrl + '/' + entityId).then(function (response) {
                return response.data;
            });
        };

        function updateEntityProfile(entityId, entity) {
            return $http.post(baseUrl + '/' + entityId, entity).then(function (response) {
                return response.data;
            });
        }

        return {
            loadEntityProfile: loadEntityProfile,
            updateEntityProfile: updateEntityProfile
        }
    }

    profileDataService.$inject = ['$http'];

    angular.module('ecap.common').service('profileDataService', profileDataService);
})();